import usePopups from "@/stores/popupsStore"
import { defineComponent, type Popup, type ReactiveComponent } from "vue-utils"
import Modal from "./Modal"

const Popups: ReactiveComponent = () => {
	const popups = usePopups()
	const popup = popups.topPopup

	return () => {
		if (!popup.value) {
			return null
		}
		const Content = popup.value.content
		return (
			<Modal
				zIndex={4}
				style={{
					minWidth: `min(${popup.value.width ?? "28rem"}, calc(100vw - 4rem))`,
					width: popup.value.width ?? "22.5%",
				}}
				closeDefault={() => {
					if (popup.value && popup.value.closable) {
						popup.value.onClose?.()
						popups.closePopup(popup.value)
					}
				}}
			>
				<Content close={() => popups.closePopup(popup.value as Popup)} popup={popup.value} />
			</Modal>
		)
	}
}

export default defineComponent(Popups)
